import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {createSelector} from 'reselect';

import * as styles from '../../styles';
import PaginatedContainer from '../../paginator/paginated_container';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import filtersSelectorGenerator from '../students/filters';


export default class ExaminationStudents extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFieldsSelector = createSelector(
        [
            () => this.context.user.id,
            () => this.props.type,
        ],
        () => [
            ...this.context.user.hasPerm('examination.reports')
                ? [{field: 'id', label: window.gettext('ID')}]
                : [],
            {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
            {field: item => item.grade ? item.grade.title : '-', label: window.gettext('Grade')},
            {field: 'national_id', label: window.gettext('National ID')},
            ...this.context.user.hasPerm('examination.analyze')
                ? [
                    {field: item => item.base_analyze ? window.gettext('Base Analyze') : window.gettext('Second Analyze')},
                ]
                : [],
            ...this.context.user.hasPerm('student.get')
                ? [
                    {field: item => item.school ? item.school.name : '-', label: window.gettext('School')},
                    {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
                    {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
                ]
                : [],
            ...this.props.type === 1
                ? [
                    {
                        field: item => window.pgettext('examination', 'Status-' + (() => {
                            if (item.read_papers > 0)
                                return 8;
                            else
                                return 2;
                        })()),
                        label: window.gettext('Status'),
                    },
                    {
                        field: item => (item.read_papers > 0 && (this.context.user.permissions.length == 0 || !this.context.user.hasPerm('teacher.teacher')))
                            ? <button
                                key='report'
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Report')}
                            </button>
                            : null,
                    },
                ]
                : [
                    {
                        field: item => window.pgettext('examination', 'Status-' + (() => {
                            if (item.marked_students === 1)
                                return 8;
                            else if (item.read_papers > 0)
                                return 7;
                            else
                                return 2;
                        })()),
                        label: window.gettext('Status'),
                    },
                    {
                        field: item => `${item.read_papers} ${window.gettext('from')} ${item.pages}`.persian(),
                        label: window.gettext('Read Papers'),
                        style: item => item.read_papers > 0 && item.read_papers < item.pages
                            ? {
                                backgroundColor: styles.alertBackColor,
                                color: styles.alertColor,
                            }
                            : item.read_papers === item.pages
                                ? {
                                    backgroundColor: styles.successBackColor,
                                    color: styles.successColor,
                                }
                                : {},
                    },
                    {
                        field: item => `${item.marked_questions} ${window.gettext('from')} ${item.questions}`,
                        label: window.gettext('Marked Questions'),
                    },
                    {
                        style: {width: '1px'},
                        field: item => item.read_papers > 0 || item.published_key
                            ? <button
                                key='key'
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/paper/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {item.read_papers > 0
                                    ? window.gettext('Paper')
                                    : window.gettext('Key')
                                }
                            </button>
                            : null,
                        label: window.gettext('Paper') + '/' + window.gettext('Key'),
                    },
                    {
                        style: {width: '1px'},
                        field: item => item.marked_students
                            ? <button
                                key='report'
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/report/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Report')}
                            </button>
                            : null,
                        label: window.gettext('Report'),
                    },
                ],
        ],
    )

    studentsFiltersSelector = filtersSelectorGenerator()
    filtersSelector = createSelector.bind(this)(
        [store => this.studentsFiltersSelector(store)],
        studentsFilters => [
            {
                field: 'examination',
                selected: {[this.props.params.examinationId]: null},
            },
            ...studentsFilters,
        ]
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
        {name: 'grade', label: window.gettext('Grade')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0 && this.context.user.hasPerm('examination.analyze')
                    ? [
                        {
                            label: window.gettext('Add to base analyze'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna add these %(count)s students to base analyze?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: `/examination/${this.props.params.examinationId}/add_to_base_analyze/`,
                                    body: {id: this.props.store.getIn(['paginator', 'selected']).keySeq()},
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                            },
                        },
                        {
                            label: window.gettext('Remove from base analyze'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s students from base analyze?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: `/examination/${this.props.params.examinationId}/remove_from_base_analyze/`,
                                    body: {id: this.props.store.getIn(['paginator', 'selected']).keySeq()},
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                            },
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
        ],
        () => _.concat(
            [
                {
                    label: window.gettext('Back'),
                    action: () => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params))),
                },
            ],
            this.props.buttonActions,
        ),
    )

    render() {
        return <span>
            <span style={{display: this.props.children ? 'none' : undefined}}>
                <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    resource='student'
                    style={this.style}
                    listFields={this.listFieldsSelector(this.props.store, this.props)}
                    tooltip={null}
                    title={window.gettext('Students')}
                    selectable
                    events={{onClick: () => null}}
                    filters={this.filtersSelector(this.props.store)}
                    sorts={this.sorts}
                    pageSize={this.props.pageSize}
                    actions={this.actionsSelector(this.props.store)}
                    buttonActions={this.buttonActionsSelector(this.props.store)}
                />
            </span>
            {this.props.children}
        </span>;
    }
}
